import React, { Component } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LoadingCircular from "../LoadingCircular";

class SabtSefaresh extends Component {
  state = {
    step: 1,
    isLoading: false,
    companyName: "",
    telephone: "",
    email: "",
    website: "",
    orderType: "",
    qty: "",
    tasvie: "",
    comment: "",
  };
  onSubmit = async (e) => {
    e.preventDefault();
    if (
      this.state.companyName === "" ||
      this.state.telephone === "" ||
      this.state.orderType === "" ||
      this.state.qty === ""
    ) {
      alert("لطفا موارد ستاره دار را تکمیل نمایید");
      return;
    }
    //send to api
    const order = {
      UserMobile: this.props.mobileNumber,
      CompanyName: this.state.companyName,
      Telephone: this.state.telephone,
      Email: this.state.email === "" ? null : this.state.email,
      Website: this.state.website === "" ? null : this.state.website,
      OrderType: this.state.orderType,
      QTY: this.state.qty,
      Pay: this.state.tasvie === "" ? null : this.state.tasvie,
      Comment: this.state.comment === "" ? null : this.state.comment,
    };
    this.setState({ isLoading: true });
    const res = await fetch("/ng/api/Orders", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(order),
    });
    const dataBack = await res.json();
    this.setState({ isLoading: false });
    if (dataBack.Result === "Ok") {
      this.setState({ step: 2 });
    } else {
      alert("پاسخی از سرور دریافت نشد");
    }
  };
  render() {
    const { step, isLoading } = this.state;
    switch (step) {
      case 1:
        return (
          <Stack
            component="form"
            spacing={1.5}
            noValidate
            autoComplete="off"
            onSubmit={this.onSubmit}
          >
            <LoadingCircular open={isLoading} />
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              ثبت سفارش
            </Typography>
            <TextField
              required
              label="نام شرکت"
              variant="standard"
              onChange={(e) => {
                this.setState({ companyName: e.target.value });
              }}
            />
            <TextField
              required
              label="شماره تماس"
              variant="standard"
              onChange={(e) => {
                this.setState({ telephone: e.target.value });
              }}
            />
            <TextField
              label="ایمیل"
              type="email"
              variant="standard"
              onChange={(e) => {
                this.setState({ email: e.target.value });
              }}
            />
            <TextField
              label="وب سایت"
              variant="standard"
              onChange={(e) => {
                this.setState({ website: e.target.value });
              }}
            />
            <FormControl fullWidth sx={{ paddingTop: 3 }}>
              <InputLabel sx={{ paddingTop: 3 }} id="lbl1">
                نوع سفارش *
              </InputLabel>
              <Select
                required
                //sx={{ mt: 4 }}
                labelId="lbl1"
                value={this.state.orderType}
                id="demo-simple-select"
                label="نوع سفارش *"
                onChange={(e) => {
                  this.setState({ orderType: e.target.value });
                }}
              >
                <MenuItem value="آمیژان">آمیژان</MenuItem>
                <MenuItem value="شمش آلومینیوم">شمش آلومینیوم</MenuItem>
                <MenuItem value="گرانول">گرانول</MenuItem>
                <MenuItem value="بیلت">بیلت</MenuItem>
                <MenuItem value="خدمات">خدمات</MenuItem>
              </Select>
            </FormControl>

            <TextField
              required
              label="مقدار(کیلوگرم)"
              variant="standard"
              type="tel"
              onChange={(e) => {
                this.setState({ qty: e.target.value });
              }}
            />
            <TextField
              label="نحوه تسویه"
              variant="standard"
              onChange={(e) => {
                this.setState({ tasvie: e.target.value });
              }}
            />
            <TextField
              label="توضیحات"
              variant="standard"
              onChange={(e) => {
                this.setState({ comment: e.target.value });
              }}
            />

            <Button type="submit" variant="contained">
              ثبت
            </Button>
          </Stack>
        );
      case 2:
        return (
          <Typography sx={{ textAlign: "center" }}>
            سفارش شما با موفقیت ثبت و به زودی بررسی خواهد شد{" "}
          </Typography>
        );
      default:
    }
  }
}

export default SabtSefaresh;
